export function Notmobile() {
	return (
		<div className="page-404">
			<div className="container">
				<h1 className="logo-font">Не доступно для компьютера</h1>
				<p>Используйте мобильное устройство для регистрации сотрудников на смену</p>
			</div>
		</div>
	);
}
